import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'rk-statistics-empty-state',
  imports: [TranslatePipe],
  templateUrl: './statistics-empty-state.component.html',
  styleUrl: './statistics-empty-state.component.scss',
})
export class StatisticsEmptyStateComponent {}
